import axios from 'axios';
import { API as baseURL } from '../config/api';
import platform from 'config/platform';
import { getCsrfToken, setPendingCsrfToken } from './csrf';

const URL_TOKEN_REFRESH = 'api/auth/refresh';
const REFRESH_RATIO = 0.85; // proactively refresh at 85% of the session TTL

let tokenRefreshRequest = null;

export const refreshToken = () => {

    if (!tokenRefreshRequest) {
        const csrfToken = getCsrfToken();
        // Always attempt the call and let the backend be authoritative on session
        // state - cookie *readability* via document.cookie isn't a reliable proxy
        // for it (varies by domain/deployment). Just never send a malformed value:
        // omit the header entirely rather than setting it to null.
        const headers = csrfToken ? { platform, 'X-CSRF-Token': csrfToken } : { platform };

        tokenRefreshRequest = axios.post(URL_TOKEN_REFRESH, null, {
                baseURL,
                withCredentials: true,
                headers
            })
            .then(response => {
                tokenRefreshRequest = null;
                const { expires_in, csrf_token } = response?.data || {};
                if (!expires_in) {
                    return Promise.reject(response);
                }
                setPendingCsrfToken(csrf_token);
                return { expires_in, csrf_token };
            })
            .catch(err => {
                tokenRefreshRequest = null;
                return Promise.reject(err);
            });
    }

    return tokenRefreshRequest;
}

let refreshTimer = null;

export const cancelScheduledRefresh = () => {
    if (refreshTimer) {
        clearTimeout(refreshTimer);
        refreshTimer = null;
    }
}

export const scheduleRefresh = (expiresIn, onFailure) => {
    cancelScheduledRefresh();

    if (!expiresIn) {
        return;
    }

    refreshTimer = setTimeout(() => {
        refreshToken()
            .then(({ expires_in }) => scheduleRefresh(expires_in, onFailure))
            .catch(() => {
                cancelScheduledRefresh();
                onFailure && onFailure();
            });
    }, expiresIn * 1000 * REFRESH_RATIO);
}
